import { useEffect } from "react";

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

export default function PageMeta({
  title,
  description,
  keywords,
  ogImage = "https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/eff900376d0ae7cc09521c15ed9fd91b.png",
  ogType = "website",
  canonical,
}: PageMetaProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        (el as HTMLMetaElement).name = name;
        document.head.appendChild(el);
      }
      (el as HTMLMetaElement).content = content;
    };

    const setProperty = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        (el as HTMLMetaElement).setAttribute("property", property);
        document.head.appendChild(el);
      }
      (el as HTMLMetaElement).content = content;
    };

    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    setProperty("og:title", title);
    setProperty("og:description", description);
    setProperty("og:type", ogType);
    setProperty("og:image", ogImage);
    setProperty("og:locale", "zh_TW");
    setProperty("og:site_name", "來加綉綉紅豆餅");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        (link as HTMLLinkElement).rel = "canonical";
        document.head.appendChild(link);
      }
      (link as HTMLLinkElement).href = canonical;
    }

    return () => {
      document.title = "來加綉綉紅豆餅｜現烤手作車輪餅｜冷凍宅配禮盒｜加盟創業";
    };
  }, [title, description, keywords, ogImage, ogType, canonical]);

  return null;
}